//
// Copyright 2023 DXOS.org
//

import * as enUS from './locales/en-US';

export const osTranslations = { 'en-US': enUS };
